4 - "use client";
import React from "react";
const brands = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/b5706f1be_58dae4e4d_BD_Australia_Logo.webp",
  alt: "B&D Australia"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/24bd15fa9_a095621ff_Merlin-Logo-Positive.webp",
  alt: "Merlin"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/7656bc9c2_c348bc03e_gliderol-logo.webp",
  alt: "Gliderol"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/liftmaster.webp",
  alt: "LiftMaster"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/steel-line-garage-doors.webp",
  alt: "Steel-Line"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/marantec.webp",
  alt: "Marantec"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doors-industrial.webp",
  alt: "4D Industrial"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/grifco.png",
  alt: "Grifco"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ata-logo-min-300x226.png.webp",
  alt: "ATA"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/5e385702d_6c94e3d82_superliftlogo-1.png",
  alt: "Superlift"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/centurion-garage-doors.webp",
  alt: "Centurion"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doors-industrial.webp",
  alt: "4 Doors"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/hormann.webp",
  alt: "Horman"
}];
export default function Manufacturermarquee() {
  return <section data-section-id="257807" id="manufacturermarquee" className="relative bg-white overflow-hidden">
      {}
      <div className="flex justify-center pt-2">
        <div className="w-[200px] h-[2.5px] rounded-lg bg-[#F5A623]/50" />
      </div>

      <div className="pt-8 pb-12">
        {}
        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-lg text-[12px] font-bold text-[#F5A623] bg-gradient-to-br from-[#F5A623]/20 to-[#F5A623]/5 border border-[#F5A623]/15 font-sans leading-none">20+</span>
          <span className="text-[13px] font-medium font-sans !text-[rgba(245,166,35,1)]">
            Australian & International Brands Serviced
          </span>
        </div>

        {}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-20 z-10 pointer-events-none" style={{
        background: "linear-gradient(to right, #FFFFFF, transparent)"
      }} />
        {}
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-20 z-10 pointer-events-none" style={{
        background: "linear-gradient(to left, #FFFFFF, transparent)"
      }} />

        {}
        <div className="relative overflow-hidden group">
          <div className="flex items-center w-max group-hover:[animation-play-state:paused]" style={{
          animation: "marqueeScroll 35s linear infinite"
        }}>
            {[...brands, ...brands].map((brand, i) => <img key={i} data-index={i} src={brand.src} alt={brand.alt} width="120" height="32" loading="lazy" decoding="async" className="h-6 md:h-8 w-auto object-contain px-4 md:px-6 shrink-0 grayscale opacity-35 hover:grayscale-0 hover:opacity-100 hover:scale-[1.06] transition-all duration-400 cursor-default select-none" />)}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}